var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_container"},[_c('Header'),_c('div',{staticClass:"wrapper py-4"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }